import { render, staticRenderFns } from "./BmwForm.vue?vue&type=template&id=48154c79&scoped=true&"
import script from "./BmwForm.vue?vue&type=script&lang=js&"
export * from "./BmwForm.vue?vue&type=script&lang=js&"
import style0 from "./BmwForm.vue?vue&type=style&index=0&id=48154c79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48154c79",
  null
  
)

export default component.exports